import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

import { User } from './types/auth'

export const userAtom = atomWithStorage<User | null>('user', null)

export const isAuthenticatedAtom = atom((get) => !!get(userAtom))

export const isDeleteAccountSuccessDialogOpenAtom = atomWithStorage<boolean>(
	'deleteAccountSuccessDialogOpen',
	false,
)

export const hasNavigatedAtom = atom(false)
